export default __webpack_public_path__ + "b5358dc7dc097e71209a765e4758e49a.svg";